export const DEPLOYMENT_REQUESTS_PATH = '/deployment-requests';

// Same rule as the backend default (now + 1h, rounded up to the next full hour).
export const DEFAULT_APPROVAL_WINDOW_HOURS = 1;

// Open the device's Deployments tab on the requests segment, or on the jobs segment with
// one job's logs already open. Transient: the toggle owns the segment from the first
// render on, and neither is saved with the table's filters (TRANSIENT_QUERY_PARAMS).
export const DEPLOYMENTS_SEGMENT_QUERY_PARAM = 'deployments_segment';
export const DEPLOYMENTS_JOB_QUERY_PARAM = 'deployments_job';

// Carried into the project comparison so the viewer can show the request it was
// opened from and offer its actions there.
export const DEPLOYMENT_REQUEST_QUERY_PARAM = 'deployment_request';
